__turbopack_context__.v({
  "hide": "ErrorText-module__r1BsgW__hide",
  "root": "ErrorText-module__r1BsgW__root" + " " + __turbopack_context__.i(95264)["paragraphStyles"],
});
